import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldCheck3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shield-check-3, check"} maskId="square-filled-radius-0-stroke-1-IconShieldCheck3"><path fillRule="evenodd" clipRule="evenodd" d="M21 5.16511L12 1.45923L3 5.16511V13C3 17.9705 7.02944 22 12 22C16.9706 22 21 17.9705 21 13V5.16511ZM10.9166 14.9708L15.9569 9.73661L15.2366 9.04297L10.9166 13.5291L8.76329 11.293L8.04297 11.9866L10.9166 14.9708Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShieldCheck3;
